<script setup>
</script>

<template>
    <!-- diskografie -->
    <ins class="adsbygoogle"
        style="display:block"
        data-ad-client="ca-pub-6165640528913711"
        data-ad-slot="6580383851"
        data-ad-format="auto"
        data-full-width-responsive="true">
    </ins>
</template>
